import React, {
  useRef,
  ReactNode,
  useEffect,
  useState,
  MutableRefObject,
} from 'react';
import {
  withStyles,
  FormControl,
  NativeSelect,
  NativeSelectProps,
  FormHelperText,
} from '@material-ui/core';
// import { variant } from '../../main_consts';

// export const SelectChange = UpdateData => e => {
//     UpdateData({ [e.target.name]: e.target.value });
// }

const StyledSelect = withStyles({
  select: {
    padding: '0.675em 2.1em 0.675em 0.75em',
    fontSize: '1.15em',
  },
})(NativeSelect);

export const StyleFormHelperText = withStyles(() => ({
  root: {
    margin: '0 19px',
  },
}))(FormHelperText);

export interface Ioption {
  value: string;
  label: string;
  disabled?: boolean;
  [key: string]: string | boolean | undefined;
}

interface ISelect extends NativeSelectProps {
  options?: Ioption[];
  ref?: MutableRefObject<HTMLSelectElement>;

  error?: boolean;
  helperText?: ReactNode;
  verifyBeforeChange?: boolean;
  verifiers?: IVerifier[];
}

interface IVerifier {
  func: (value: unknown) => boolean;
  text: string;
}
// html required 無效，因為 input hidden
const Select = (props: ISelect): JSX.Element => {
  const {
    value,
    required,
    ref = useRef(),
    verifyBeforeChange = false,
    options = [],
    error,
    helperText,
    verifiers = [],
    style,
    placeholder = '請選擇…',
    ...other
  } = props;
  const [message, setMessage] = useState('');
  const [FirstVerify, setFirstVerify] = useState(verifyBeforeChange);

  useEffect(() => {
    // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
    if (!FirstVerify) {
      setFirstVerify(true);
      setMessage('');
      return;
    }

    // 驗 HTML validation
    if (ref.current) {
      const { validationMessage } =
        ref.current.getElementsByTagName('select')[0];
      if (validationMessage.length > 0) {
        setMessage(validationMessage);
        return;
      }
    }

    // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
    if (props.value && verifiers.length > 0) {
      const veriObj = verifiers.find((obj) => obj.func(value));
      if (veriObj) {
        setMessage(veriObj.text);
        return;
      }
    }

    // 先前檢驗都 pass
    setMessage('');
  }, [value, verifyBeforeChange]);

  return (
    <FormControl error={error || message.length > 0} style={{ width: '100%' }}>
      <StyledSelect
        {...other}
        value={value}
        // input={variant && <OutlinedInput />}
        ref={ref}
        required={required}
        style={{
          ...style,
          color: !value && placeholder ? 'gray' : 'initial',
        }}
      >
        {placeholder ? (
          <option value="" hidden>
            {placeholder}
          </option>
        ) : (
          options.findIndex((obj) => obj.value === '') === -1 && (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <option value="" hidden />
          )
        )}
        {options.map((obj) => (
          <option
            key={obj.value}
            value={obj.value}
            style={{ color: !obj.value && placeholder ? 'gray' : 'initial' }}
          >
            {obj.label}
          </option>
        ))}
      </StyledSelect>
      <StyleFormHelperText>{helperText || message}</StyleFormHelperText>
    </FormControl>
  );
};

export default Select;
